import { Constants } from "../../data/constants";
import { HttpService } from "../../utils/HttpService";

export class CfgAccountService {
  constructor() {
    this.constants = new Constants();
    this.HttpService = new HttpService();
  }

  getAllAccountsService = async session_id => {
    try {
      return await this.HttpService.getJson(
        this.constants.cfgAccountServicesURLs.getCfgAccounts,
        session_id
      );
    } catch (e) {
      throw e;
    }
  };

  getCfgsAccountService = async session_id => {
    try {
      return await this.HttpService.getJson(
        this.constants.cfgAccountServicesURLs.getCfgsAccount,
        session_id
      );
    } catch (e) {
      throw e;
    }
  };
  getAccountCFGServiceById = async (session_id, accountId) => {
    try {
      return await this.HttpService.getJson(
        this.constants.cfgAccountServicesURLs.getCfgAccounts +
          "accountID/" +
          `${accountId}`,
        session_id
      );
    } catch (e) {
      throw e;
    }
  };
  getSpecificCfg = async (session_id, accountId, key, confiCategory) => {
    try {
      return await this.HttpService.getJson(
        this.constants.cfgAccountServicesURLs.getCFGAccount +
          "/" +
          `${accountId}` +
          "/key/" +
          `${key}` +
          "/confiCategory/" +
          `${confiCategory}`,
        session_id
      );
    } catch (e) {
      throw e;
    }
  };
  getAccountsByIdService = async (session_id, accountId) => {
    try {
      return await this.HttpService.getJson(
        this.constants.cfgAccountServicesURLs.getCfgAccounts + `byAccountId/`,
        session_id
      );
    } catch (e) {
      throw e;
    }
  };

  editCfgAccount = async (session_id, Account) => {
    try {
      return await this.HttpService.putJson(
        this.constants.cfgAccountServicesURLs.editCfgAccount,
        {
          key: Account.key,
          value: Account.value,
          configCategory: Account.configCategory,
          accountID: Account.accountID,
        },
        session_id
      );
    } catch (e) {
      throw e;
    }
  };

  getCurrentConcurrentCalls = async (session_id, groupId) => {
    try {
      return await this.HttpService.getJson(
        this.constants.cfgAccountServicesURLs.getCurrentConcurrentCalls +
          `${groupId}`,
        session_id
      );
    } catch (e) {
      throw e;
    }
  };
}
